let clockManagerObj = {};

module.exports = function ClockManager() {
	console.log('Inicializa a clockManager')
	return clockManagerObj;
}

clockManagerObj.execInterval = () => {
	if(clockManagerObj.timeListener!=null) {
		var endTime = new Date();
		var timeDiff = Math.floor((endTime - clockManagerObj.startTime)/1000);

		var hours = Math.floor(timeDiff/3600);
		if(hours>0) {
			timeDiff-=(hours*3600);
			if(hours>9) hours=9;
			hours = hours + "h+";
		}
		else {
			hours = "";
		}

		var seconds = timeDiff%60;
		var minutes = Math.floor(timeDiff/60);

		if(seconds<0) seconds=0;
		if(minutes<0) minutes=0;

		if(seconds<10)seconds = "0" + seconds;
		if(minutes<10)minutes = "0" + minutes;
		
		clockManagerObj.timeListener(hours + minutes + ":" + seconds);
	}
}

clockManagerObj.start = function(offset) {	
	clockManagerObj.startTime = new Date()-offset;	
	clockManagerObj.intervalFn = setInterval( clockManagerObj.execInterval,1000 )
}

clockManagerObj.setTimeListener = function(timeListener) {
	clockManagerObj.timeListener = timeListener;	
}

clockManagerObj.stop = function() {
	clearInterval(clockManagerObj.intervalFn);
	clockManagerObj.startTime = null;
}


// WEBPACK FOOTER //
// ./src/containers/utils/ClockManager.js